import { Text, View } from '@react-pdf/renderer';
import { Show } from '@ui/components/Show';

import { PDFQuoteLineType } from '../../../PDFProvider';
import { formatLineNumber } from '../../utils/format-line-number';
import { styles } from '../styles';
import { PartDescription } from './PartDescription';
import { PartInformation } from './PartInformation';
import { PartSpecs } from './PartSpecs';

type QuoteLineForServicesProps = PDFQuoteLineType & {
  showDescription?: boolean;
};

export function QuoteLineForServices({
  lineNumber,
  quotePrices,
  serviceCharge,
  showDescription,
  specs,
}: QuoteLineForServicesProps) {
  if (!serviceCharge) {
    return null;
  }

  const { quantity, unitPrice, total } = quotePrices[0];
  return (
    <View style={[styles.gap10, styles.column, styles.wrapper]} wrap={false}>
      <View style={[styles.gap10, styles.row]}>
        <View style={styles.column}>
          <Text>Line Number {formatLineNumber(lineNumber)}</Text>
        </View>

        <PartInformation>
          <View>
            <Text style={[styles.bold, { paddingBottom: '4px' }]}>
              {serviceCharge.id} (SERVICE)
            </Text>
          </View>

          <Show when={showDescription}>
            <PartDescription description={serviceCharge.description} />
          </Show>
          <PartSpecs specs={specs} />
        </PartInformation>

        <View style={[styles.column, styles.leftColumnWrapper]}>
          <View style={{ minWidth: '110pt' }}>Thing</View>
          <View
            style={[
              styles.gap10,
              styles.row,
              styles.widthFull,
              { justifyContent: 'space-between' },
            ]}
          >
            <View style={[styles.alignEnd, styles.column, styles.gap4]}>
              <Text style={styles.underline}>Quantity</Text>
              <Text>{quantity}</Text>
            </View>
            <View style={[styles.alignEnd, styles.column, styles.gap4]}>
              <Text style={styles.underline}>Unit Price</Text>
              <Text>{unitPrice}</Text>
            </View>
            <View style={[styles.alignEnd, styles.column, styles.gap4]}>
              <Text style={styles.underline}>Price</Text>
              <Text>{total}</Text>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
}
